const findCaseAttribute = (dataName, caseTypeAttributes) => {
  return caseTypeAttributes.find(
    (attribute) => attribute.data_name === dataName,
  )
}

export default findCaseAttribute
